import type { TopicResource } from '../types/api'

/**
 * Thread-scoped rows for a resolving thread, from the topic pool cache
 * (the same key every surface warms). Empty when the cache is cold —
 * the resolve prompt simply doesn't fire, which is the safe default.
 */
export function threadScopedRows(
  client: { getQueryData: (key: readonly unknown[]) => unknown },
  topicId: string,
  threadId: string,
): TopicResource[] {
  const data = client.getQueryData(['resources', 'topic', topicId]) as
    | { resources?: TopicResource[] }
    | undefined
  return (data?.resources ?? []).filter((r) => r.thread_id === threadId)
}
